export enum EducationalAttainment {
  HIGHSCHOOL = 'HIGHSCHOOL',

  UNIVERSITY = 'UNIVERSITY',

  TERTIARY = 'TERTIARY',

  POSTGRADUATE = 'POSTGRADUATE',
}
